module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-expandable-sparks.35c0dc14.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-expandable-sparks.png
// module id = 3841
// module chunks = 11